import axios from '../setup/axios';
import config from '../setup/config';

export default {
    async getChatOverview(clientId, startDate, endDate) {
        const result = await axios.get(`${config.microservices.reports}/`, {
            params: {
                clientId,
                report: 'chatOverview',
                startDateTime: new Date(startDate).getTime(),
                endDateTime: new Date(endDate).getTime(),
            }
        });
        return result.data;
    },
    async getChatLeads(clientId, startDate, endDate) {
        const path = `${config.microservices.supportToolsApi}/reporting/chat/leads`;
        const result = await axios.get(path, {
            params: {
                clientId,
                startDate: new Date(startDate).toISOString(),
                endDate: new Date(endDate).toISOString()
            }
        });
        return result.data;
    },
    async getMonthlyPerformance(clientId) {
        const path = `${config.microservices.supportToolsApi}/reporting/chat/monthly-performance`;
        const result = await axios.get(path, {
            params: {
                clientId,
            }
        });
        return result.data;
    },
    async getAgentActivity(clientId) {
        const path = `${config.microservices.supportToolsApi}/reporting/chat/agent-activity`;
        const result = await axios.get(path, {
            params: {
                clientId,
            }
        });
        return result.data;
    },
    async addCsmNote(note) {
        const path = `${config.microservices.supportToolsApi}/client/note`;
        const result = await axios.post(path, {
            clientId: note.clientId,
            text: note.text,
        });
        return result.data;
    },
    async getNotesByClientId(clientId) {
        const path = `${config.microservices.supportToolsApi}/client/notes`;
        const result = await axios.get(path, {
            params: {
                clientId,
            }
        });
        return result.data;
    },
    async getSystemScoreByClientId(clientId) {
        const result = await axios.get(`${config.microservices.supportToolsApi}/reporting/chat-system-rating/${clientId}`);
        return result.data;
    },
    async getClientsLatestHealthScore() {
        const result = await axios.get(`${config.microservices.supportToolsApi}/reporting/health-score/latest`);
        return result.data;
    },
    async getClientLatestHealthScore(clientId) {
        const result = await axios.get(`${config.microservices.supportToolsApi}/reporting/health-score/`, {
            params: {
                clientId
            }
        });
        return result.data;
    },
    async getClientsLatestRating() {
        const result = await axios.get(`${config.microservices.supportToolsApi}/reporting/chat-system-rating/latest`);
        return result.data;
    }
}
